import { type ReactNode } from 'react';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <div className="min-h-dvh bg-[color:var(--kz-color-surface-page)] text-[color:var(--kz-color-ink-primary)]">
      <header className="container mx-auto max-w-6xl px-6 py-6">
        <a href="https://kidzio.io" className="inline-flex items-center gap-2">
          <img src="/logo-mark.svg" alt="Kidzio" width={32} height={32} className="h-8 w-8" />
          <span className="text-lg font-semibold">kidzio</span>
        </a>
      </header>

      <main className="container mx-auto flex max-w-md flex-col px-6 pb-16 pt-6">
        <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && (
          <p className="mt-2 text-sm text-[color:var(--kz-color-ink-secondary)]">{subtitle}</p>
        )}
        <div className="mt-8">{children}</div>
        {footer && (
          <div className="mt-8 text-center text-sm text-[color:var(--kz-color-ink-secondary)]">
            {footer}
          </div>
        )}
      </main>
    </div>
  );
}
